export default __webpack_public_path__ + "static/media/vikalp..f13d5c61.png";